import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const SapnaEnclavePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  // Add animation classes
  useEffect(() => {
    const addAnimationClasses = () => {
      const style = document.createElement('style');
      style.textContent = `
        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.6s ease-out forwards;
        }
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
        .animate-pulse-slow {
          animation: pulse 3s ease-in-out infinite;
        }
      `;
      document.head.appendChild(style);
      setIsLoaded(true);
    };
    
    addAnimationClasses();
  }, []);
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50">
      {/* Hero Section with Gradient Background */}
      <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 text-white py-16 px-4 shadow-lg relative overflow-hidden">
        {/* Animated background elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-20 pointer-events-none">
          <div className="absolute w-64 h-64 rounded-full bg-white/10 -top-20 -left-20 animate-pulse-slow"></div>
          <div className="absolute w-96 h-96 rounded-full bg-white/10 -bottom-40 -right-20 animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
          <div className="absolute w-32 h-32 rounded-full bg-white/10 top-1/4 right-1/4 animate-pulse-slow" style={{ animationDelay: '2s' }}></div>
        </div>
        <div className="container mx-auto">
          <div className={`max-w-4xl mx-auto text-center transition-all duration-700 ${isLoaded ? 'animate-fade-in-up' : 'opacity-0'}`} style={{ animationDelay: '0.2s' }}>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold mb-6 drop-shadow-md">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-white to-blue-200">Aasra Sapna Enclave</span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto mb-8">
              Welcome to your modern residential community portal
            </p>
            <div className="flex flex-wrap justify-center gap-4 mt-8">
              <Link to="/vehicle-registration" className="bg-white text-indigo-600 hover:bg-blue-50 font-bold py-3 px-6 rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M8 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM15 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z" />
                  <path d="M3 4a1 1 0 00-1 1v10a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H10a1 1 0 001-1v-5h2.05a2.5 2.5 0 014.9 0H19a1 1 0 001-1v-5a1 1 0 00-1-1h-8a1 1 0 00-.8.4L8.65 6H5a2 2 0 00-2 2v3a1 1 0 001 1h1.05a2.5 2.5 0 014.9 0H13" />
                </svg>
                Register Vehicle
              </Link>
              <Link to="/vehicle-lookup" className="bg-white text-purple-600 hover:bg-blue-50 font-bold py-3 px-6 rounded-full shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-105 flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                </svg>
                Lookup Vehicle
              </Link>
            </div>
          </div>
        </div>
      </div>
      
      {/* Features Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-indigo-800 mb-4">Community Services</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore the digital services available to Sapna Enclave residents
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto">
          {/* Vehicle Registration Card */}
          <div className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl group">
            <div className="h-3 bg-yellow-400"></div>
            <div className="p-6 text-white">
              <div className="bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Vehicle Registration</h3>
              <p className="text-blue-100 mb-4">
                Register your vehicles with the society for parking and security access.
              </p>
              <Link
                to="/vehicle-registration"
                className="inline-block bg-white text-blue-600 hover:bg-blue-50 font-medium py-2 px-5 rounded-full transition duration-300 transform hover:scale-105"
              >
                Register Now
              </Link>
            </div>
          </div>

          {/* Visitor Management Card */}
          <div className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl group">
            <div className="h-3 bg-green-400"></div>
            <div className="p-6 text-white">
              <div className="bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Visitor Management</h3>
              <p className="text-purple-100 mb-4">
                Pre-approve visitors and manage their access to the society premises.
              </p>
              <div className="relative">
                <button
                  className="inline-block bg-white text-purple-600 font-medium py-2 px-5 rounded-full transition duration-300 opacity-50 cursor-not-allowed"
                  disabled
                >
                  Coming Soon
                </button>
                <div className="absolute -top-2 -right-2 bg-yellow-400 text-xs text-yellow-800 font-bold px-2 py-1 rounded-full">SOON</div>
              </div>
            </div>
          </div>

          {/* Vehicle Owner Lookup Card */}
          <div className="bg-gradient-to-br from-indigo-500 to-indigo-600 rounded-xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl group">
            <div className="h-3 bg-pink-400"></div>
            <div className="p-6 text-white">
              <div className="bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Vehicle Owner Lookup</h3>
              <p className="text-indigo-100 mb-4">
                Look up vehicle owner details by providing a registration number.
              </p>
              <Link
                to="/vehicle-lookup"
                className="inline-block bg-white text-indigo-600 hover:bg-indigo-50 font-medium py-2 px-5 rounded-full transition duration-300 transform hover:scale-105"
              >
                Lookup Now
              </Link>
            </div>
          </div>
          
          {/* Maintenance Requests Card */}
          <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl group">
            <div className="h-3 bg-orange-400"></div>
            <div className="p-6 text-white">
              <div className="bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Maintenance Requests</h3>
              <p className="text-teal-100 mb-4">
                Submit and track maintenance requests for your apartment or common areas.
              </p>
              <div className="relative">
                <button
                  className="inline-block bg-white text-teal-600 font-medium py-2 px-5 rounded-full transition duration-300 opacity-50 cursor-not-allowed"
                  disabled
                >
                  Coming Soon
                </button>
                <div className="absolute -top-2 -right-2 bg-yellow-400 text-xs text-yellow-800 font-bold px-2 py-1 rounded-full">SOON</div>
              </div>
            </div>
          </div>

          {/* Community Events Card */}
          <div className="bg-gradient-to-br from-pink-500 to-pink-600 rounded-xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl group">
            <div className="h-3 bg-blue-400"></div>
            <div className="p-6 text-white">
              <div className="bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Community Events</h3>
              <p className="text-pink-100 mb-4">
                Stay updated with upcoming events and activities in the community.
              </p>
              <div className="relative">
                <button
                  className="inline-block bg-white text-pink-600 font-medium py-2 px-5 rounded-full transition duration-300 opacity-50 cursor-not-allowed"
                  disabled
                >
                  Coming Soon
                </button>
                <div className="absolute -top-2 -right-2 bg-yellow-400 text-xs text-yellow-800 font-bold px-2 py-1 rounded-full">SOON</div>
              </div>
            </div>
          </div>

          {/* Bill Payments Card */}
          <div className="bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl shadow-xl overflow-hidden transform transition-all duration-300 hover:scale-[1.03] hover:shadow-2xl group">
            <div className="h-3 bg-indigo-400"></div>
            <div className="p-6 text-white">
              <div className="bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-bold mb-3">Bill Payments</h3>
              <p className="text-amber-100 mb-4">
                Pay maintenance bills and track payment history online.
              </p>
              <div className="relative">
                <button
                  className="inline-block bg-white text-amber-600 font-medium py-2 px-5 rounded-full transition duration-300 opacity-50 cursor-not-allowed"
                  disabled
                >
                  Coming Soon
                </button>
                <div className="absolute -top-2 -right-2 bg-yellow-400 text-xs text-yellow-800 font-bold px-2 py-1 rounded-full">SOON</div>
              </div>
            </div>
          </div>
        </div>

        {/* About Section */}
        <div className="mt-20 bg-white rounded-2xl shadow-xl p-8 max-w-5xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">About Sapna Enclave</h2>
            <div className="w-16 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full mb-4"></div>
          </div>
          
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-6 rounded-xl mb-8">
            <p className="text-gray-700 leading-relaxed">
              Sapna Enclave is a premium residential society offering modern amenities, 
              24/7 security, and a vibrant community atmosphere. Our digital portal aims 
              to streamline society management and enhance resident experience.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/society-rules" className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white font-medium py-3 px-6 rounded-lg transition duration-300 transform hover:scale-105 shadow-md hover:shadow-lg flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
              </svg>
              Society Rules
            </Link>
            <Link to="/contact" className="bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white font-medium py-3 px-6 rounded-lg transition duration-300 transform hover:scale-105 shadow-md hover:shadow-lg flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              Contact Management
            </Link>
          </div>
        </div>
        
        {/* Footer */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="text-gray-500 text-sm">
              <p>© 2025 Sapna Enclave Residential Society. All rights reserved.</p>
            </div>
            <div className="text-gray-500 text-sm">
              <p>Maintained by <a href="https://futuresofttech.in" target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:text-blue-700 transition-colors">Futuresoft Tech</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SapnaEnclavePage;
